/*
 * ====================================================================
 * Grow Template
 * @package  Grow Template
 * @author   GrowGroup.Inc <info@grow-group.jp>
 * @license  MIT Licence
 * ====================================================================
 */

(function ($) {
  var growApp = function () {

  };

  /************************
   * please insert your code
   *************************/
  growApp.prototype.myCode = function () {
  }

  growApp.prototype.modalContents = function () {
    $('.js-modal-content').modaal();
  }

  growApp.prototype.enterAnimation = function () {
    let $loader = $('.c-loader');
    if (!$loader.length === 0) {
      return false;
    }

    function changeClass(el, className, time) {
      return new Promise(function (resolve, reject) {
        setTimeout(function () {
          el.addClass(className);
          resolve(className);
        }, time);
      });
    }

    var loaderFunction = function () {
      // ここから実行
      if ($loader) {
        changeClass($loader, "is-active", 1000).then(function () {
          changeClass($loader, "is-close", 2000).then(function () {
            changeClass($loader, "is-hidden", 1000).then(function () {

            });
          });
        });
      }
    };

    // first entry only
    if (!sessionStorage.getItem('loading')) {
      sessionStorage.setItem('loading', true);
      loaderFunction();
    } else {
      // テストはこちらをコメントアウト外す
      // loaderFunction();
      $loader.addClass('is-already');
    }
  };

  growApp.prototype.backCache = function () {
    window.onpageshow = function(event) {
      if (event.persisted) {
        window.location.reload();
      }
    }
  }

  growApp.prototype.showCookie = function () {
    const cookie = $(".js-cookie");
    const cookieId = $("#cookie");
    const btn = $("#wt-cli-accept-all-btn");
  
    if (cookie.length || btn.length) {
  
      // クッキーから許可状態を読み込む
      const isCookiePermitted = getCookie('cookie-permission');
  
      if (isCookiePermitted === 'true') {
        cookie.addClass("is-hidden");
        return;
      }
  
      btn.click(function (e) {
        e.preventDefault();
        // クッキーに許可状態を保存
        setCookie('cookie-permission', 'true', 7); // 有効期限を7日に設定
        cookie.addClass("is-hidden");
      });
    }
  
    window.onscroll = function (e) {
      if (window.pageYOffset > 100) {
        cookieId.addClass("is-fixed");
      } else {
        cookieId.removeClass("is-fixed");
      }
    }
  }
  
  // クッキーを設定する関数
  function setCookie(name, value, days) {
    var expires = "";
    if (days) {
      var date = new Date();
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
      expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
  }
  
  // クッキーを取得する関数
  function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) == ' ') c = c.substring(1, c.length);
      if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
    }
    return null;
  }

  $(function () {
    var app = new growApp();
    app.myCode();
    app.modalContents();
    app.enterAnimation();
    app.showCookie();
  });
})(jQuery);
